<template>
  <div class="d-flex flex-column" style="height: 65vh">
    <div class="d-flex flex-row-reverse">
      <b-form-select
        v-model="file"
        :options="fileOptions"
        @change="fetchLogs"
      />
    </div>
    <ag-grid-vue
      :columnDefs="columnDefs"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      @cell-clicked="onCellClicked"
      class="ag-theme-material flex-grow-1 custom-table"
    />
    <b-modal
      title="Stacktrace"
      ok-title="ОК"
      ok-only
      ref="stackModal"
      size="xl"
    >
      <h3>Stacktrace</h3>
      <pre>
        {{ stacktrace }}
      </pre>
      <h3 v-if="queryParams">Query params</h3>
      <pre v-if="queryParams">
        {{ queryParams }}
      </pre>
    </b-modal>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import moment from 'moment'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import logsApi from '@/api/logs'

export default {
  name: 'AdminLogsTable',
  components: {
    'ag-grid-vue': AgGridVue
  },
  props: {
    type: {
      type: String
    }
  },
  data() {
    return {
      file: '',
      fileOptions: [],
      data: '',
      gridApi: null,
      stacktrace: '',
      queryParams: '',
      gridOptions: {
        pagination: true,
        paginationPageSize: 100,
        tooltipShowDelay: 250,
        defaultColDef: {
          editable: false,
          sortable: true,
          filter: true,
          resizable: true,
          cellStyle: {
            'white-space': 'nowrap',
            'justify-content': 'normal'
          },
          tooltip(params) {
            if (params.value) {
              return params.value
            }
          }
        },
        rowHeight: 26
      },
      localeText: AG_GRID_LOCALE_RU
    }
  },
  computed: {
    columnDefs() {
      if (this.type === 'info') {
        return [
          {
            field: 'timestamp',
            headerName: 'Timestamp',
            colId: 'timestamp'
          },
          {
            field: 'realIp',
            headerName: 'Real IP'
          },
          {
            field: 'authUser',
            headerName: 'User'
          },
          {
            field: 'method',
            headerName: 'Method',
            width: 100,
            filterParams: {
              keys: ['GET', 'POST', 'PUT', 'DELETE']
            }
          },
          {
            field: 'url',
            headerName: 'URL',
            width: 400
          },
          {
            field: 'status',
            headerName: 'Status',
            filter: 'agNumberColumnFilter',
            width: 100
          },
          {
            field: 'responseTime',
            headerName: 'Time (ms)',
            filter: 'agNumberColumnFilter',
            width: 100
          },
          {
            field: 'contentLength',
            headerName: 'Size (b)',
            filter: 'agNumberColumnFilter',
            width: 100
          },
          {
            field: 'referrer',
            headerName: 'Referrer'
          },
          {
            field: 'userAgent',
            headerName: 'UserAgent'
          }
        ]
      }
      return [
        {
          field: 'timestamp',
          headerName: 'Timestamp',
          colId: 'timestamp'
        },
        {
          field: 'user',
          headerName: 'User'
        },
        {
          field: 'level',
          headerName: 'Level',
          width: 100
        },
        {
          field: 'method',
          headerName: 'Method',
          width: 100,
          filterParams: {
            keys: ['GET', 'POST', 'PUT', 'DELETE']
          }
        },
        {
          field: 'path',
          headerName: 'URL',
          width: 400
        },
        {
          field: 'message',
          headerName: 'Message',
          width: 400
        }
      ]
    }
  },
  methods: {
    onGridReady({ api }) {
      this.gridApi = api
      this.fetchLogs()
    },
    async fetchLogs() {
      let index = this.fileOptions.indexOf(this.file)
      if (index < 0) {
        index = 0
      }
      const response = await logsApi.getLog(this.type, index)
      this.fileOptions = response.data.files
      this.file = this.fileOptions[index]
      this.data = response.data.data
      this.updateRowData()
    },
    updateRowData() {
      const lines = this.data.split('\n')
      const result = []
      for (const line of lines) {
        if (line.length === 0) {
          continue
        }
        let parsed
        if (this.type === 'info') {
          parsed = this.parseInfoLine(line)
        } else if (this.type === 'error') {
          parsed = this.parseErrorLine(line)
        }
        if (parsed) {
          result.push(parsed)
        }
      }
      this.gridApi.setRowData(result)
      this.gridApi.setSortModel([
        {
          colId: 'timestamp',
          sort: 'desc'
        }
      ])
    },
    parseInfoLine(line) {
      const elems = line.split(',')
      // elems.length < 11. На сервере лог в формате csv пишется в 12 столбцов. Если меньше, то в логе запись не про запрос к API
      if (elems.length < 11) {
        return null
      }
      const [method, url] = elems[6].slice(1, -1).split(' ')
      return {
        timestamp: elems[0].slice(1, -1),
        level: elems[1].slice(1, -1),
        remoteAddr: elems[2].slice(1, -1),
        realIp: elems[3].slice(1, -1),
        remoteUser: elems[4].slice(1, -1),
        authUser: elems[5].slice(1, -1),
        method,
        url,
        status: Number(elems[7].slice(1, -1)),
        responseTime: Number(elems[8].slice(1, -4)),
        contentLength: Number(elems[9].slice(1, -1)),
        referrer: elems[10].slice(1, -1),
        userAgent: elems[11].slice(1, -1)
      }
    },
    parseErrorLine(line) {
      const obj = JSON.parse(line)
      obj.timestamp = moment(obj.timestamp).format('YYYY-MM-DD HH:mm:ss')
      return obj
    },
    onCellClicked(params) {
      if (params.data.stacktrace) {
        this.stacktrace = params.data.stacktrace
        if (params.data.query) {
          this.queryParams = params.data.query
        } else {
          this.queryParams = ''
        }
        this.$refs.stackModal.show()
      }
    }
  }
}
</script>
